import { render, staticRenderFns } from "./NewMarketplace.vue?vue&type=template&id=3e47657c&scoped=true&"
import script from "./NewMarketplace.vue?vue&type=script&lang=js&"
export * from "./NewMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./NewMarketplace.vue?vue&type=style&index=0&id=3e47657c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47657c",
  null
  
)

export default component.exports